import { createApp } from "vue";
import options from "./WebshopHeader.options";
import store from "store";

const el = ".kb-component--webshop-header";
const DOM = document.querySelector(el);

export default function (store) {
    if (DOM && !DOM.hasAttribute("data-v-app")) {
        const template = DOM.outerHTML;
        options.template = template;
        store.commit(
            "basket/SET_INITIAL_BASKET_TOTALS_PRODUCTS_AMOUNT",
            DOM.dataset.initialItemsCount,
        );
        const component = createApp(options).use(store);
        component.mount(DOM);
    }
}
